import { isObject } from 'lodash'

export const sectionData = [
  { SectionCd: 1900, SectionName: `HUNTER BREEDING` },
  { SectionCd: 1901, SectionName: `HUNTER BREEDING YEARLING` },
  { SectionCd: 1902, SectionName: `HUNTER BREEDING 2 YEAR OLD` },
  { SectionCd: 1903, SectionName: `HUNTER BREEDING 3 YEAR OLD` },
  { SectionCd: 1904, SectionName: `PONY HUNTER BREEDING YEARLING` },
  { SectionCd: 1905, SectionName: `PONY HUNTER BREEDING 2 YEAR OLD` },
  { SectionCd: 1906, SectionName: `PONY HUNTER BREEDING 3 YEAR OLD` },
  { SectionCd: 1938, SectionName: `PONY HUNTER BREEDING` },
  { SectionCd: 2001, SectionName: `HIGH PERFORMANCE HUNTER` },
  { SectionCd: 2002, SectionName: `PERFORMANCE WORKING - 3'6" - 3'9"` },
  { SectionCd: 2003, SectionName: `PERFORMANCE WORKING - 3'3"` },
  {
    SectionCd: 2005,
    SectionName: `PERFORMANCE WORKING COMBINED - 3'3" AND 3'6"`,
  },
  {
    SectionCd: 2006,
    SectionName: `WORKING HUNTER SECTION (HIGH PERFORMANCE/ GREEN)`,
  },
  { SectionCd: 2150, SectionName: `GREEN HUNTER (COMBINED)` },
  { SectionCd: 2151, SectionName: `GREEN HUNTER 3'0"` },
  { SectionCd: 2152, SectionName: `GREEN HUNTER 3'3"` },
  { SectionCd: 2153, SectionName: `GREEN HUNTER 3'6"` },
  { SectionCd: 2154, SectionName: `GREEN HUNTER 3'9"` },
  { SectionCd: 2180, SectionName: `YOUNG HUNTER (Combined)` },
  { SectionCd: 2181, SectionName: `YOUNG HUNTER 5 & Under` },
  { SectionCd: 2182, SectionName: `YOUNG HUNTER 6 & Under` },
  { SectionCd: 2183, SectionName: `YOUNG HUNTER 7 & Under` },
  { SectionCd: 2300, SectionName: `CONFORMATION HUNTER` },
  { SectionCd: 2301, SectionName: `HIGH PERFORMANCE CONFORMATION HUNTER` },
  { SectionCd: 2302, SectionName: `GREEN CONFORMATION HUNTER` },
  { SectionCd: 2400, SectionName: `JUNIOR HUNTER` },
  { SectionCd: 2401, SectionName: `JUNIOR HUNTER-SMALL 15 & UNDER` },
  { SectionCd: 2402, SectionName: `JUNIOR HUNTER-LARGE 15 & UNDER` },
  { SectionCd: 2403, SectionName: `JUNIOR HUNTER-SMALL 16-17` },
  { SectionCd: 2404, SectionName: `JUNIOR HUNTER-LARGE 16-17` },
  { SectionCd: 2410, SectionName: `JUNIOR HUNTER SMALL` },
  { SectionCd: 2411, SectionName: `JUNIOR HUNTER LARGE` },
  { SectionCd: 2420, SectionName: `JUNIOR HUNTER 3'3" COMBINED` },
  { SectionCd: 2421, SectionName: `JUNIOR HUNTER 3'3" SMALL 15/U` },
  { SectionCd: 2422, SectionName: `JUNIOR HUNTER 3'3" LARGE 15/U` },
  { SectionCd: 2423, SectionName: `JUNIOR HUNTER 3'3" SMALL 16-17` },
  { SectionCd: 2424, SectionName: `JUNIOR HUNTER 3'3" LARGE 16-17` },
  { SectionCd: 2412, SectionName: `SMALL JUNIOR HUNTER 3'3"` },
  { SectionCd: 2413, SectionName: `LARGE JUNIOR HUNTER 3'3"` },
  { SectionCd: 2200, SectionName: `AMATEUR OWNER HUNTER` },
  { SectionCd: 2201, SectionName: `AMATEUR OWNER HUNTER 18-35 YEARS` },
  { SectionCd: 2202, SectionName: `AMATEUR OWNER HUNTER 35+ YEARS` },
  { SectionCd: 2203, SectionName: `AMATEUR OWNER HUNTER 3'3" (COMBINED AGES)` },
  { SectionCd: 2204, SectionName: `AMATEUR OWNER HUNTER 3'3" - 18-35` },
  { SectionCd: 2205, SectionName: `AMATEUR OWNER HUNTER 3'3" 36+` },
  { SectionCd: 9300, SectionName: `JUNIOR/AMATEUR OWNER HUNTER- 3'6"` },
  { SectionCd: 9303, SectionName: `JUNIOR/AMATEUR 3'3" COMBINED` },
  { SectionCd: 2004, SectionName: `SMALL HUNTERS` },
  { SectionCd: 2500, SectionName: `PONY HUNTER` },
  { SectionCd: 2501, SectionName: `PONY HUNTER-SMALL` },
  { SectionCd: 2502, SectionName: `PONY HUNTER-MEDIUM` },
  { SectionCd: 2503, SectionName: `PONY HUNTER-LARGE` },
  { SectionCd: 2600, SectionName: `GREEN PONY HUNTER` },
  { SectionCd: 2601, SectionName: `GREEN PONY HUNTER-SMALL/MEDIUM` },
  { SectionCd: 2602, SectionName: `GREEN PONY HUNTER-LARGE` },
  { SectionCd: 2603, SectionName: `GREEN PONY HUNTER-MEDIUM` },
  { SectionCd: 2604, SectionName: `GREEN PONY HUNTER-SMALL` },
  { SectionCd: 2700, SectionName: `CHILDRENS HUNTER` },
  { SectionCd: 2701, SectionName: `CHILDRENS HUNTER-PONY` },
  { SectionCd: 2702, SectionName: `CHILDRENS HUNTER-HORSE` },
  { SectionCd: 2800, SectionName: `ADULT AMATEUR HUNTER` },
  { SectionCd: 2801, SectionName: `ADULT AMATEUR HUNTER 18-35 YEARS` },
  { SectionCd: 2802, SectionName: `ADULT AMATEUR HUNTER 35+ YEARS` },
  { SectionCd: 2803, SectionName: `ADULT AMATEUR HUNTER 36-49` },
  { SectionCd: 2804, SectionName: `ADULT AMATEUR HUNTER 50+ YEARS` },
  { SectionCd: 9301, SectionName: `CHILDREN/ADULT AMATEUR HUNTER` },
  { SectionCd: 12001, SectionName: `USHJA GREEN HUNTER CHALLENGE` },
  { SectionCd: 12010, SectionName: `USHJA GREEN INCENTIVE 3/3'3"` },
  { SectionCd: 12020, SectionName: `USHJA GREEN INCENTIVE 3'6"/3'9"` },
  { SectionCd: 2050, SectionName: `USHJA HUNTER COMBINED` },
  { SectionCd: 2051, SectionName: `USHJA HUNTER - 2'0"` },
  { SectionCd: 2052, SectionName: `USHJA HUNTER - 2'3"` },
  { SectionCd: 2053, SectionName: `USHJA HUNTER - 2'6"` },
  { SectionCd: 2054, SectionName: `USHJA HUNTER - 2'9"` },
  { SectionCd: 2055, SectionName: `USHJA HUNTER - 3'0"` },
  { SectionCd: 6355, SectionName: `USHJA 3'3" ADULT JUMPING SEAT MEDAL` },
  {
    SectionCd: 3000,
    SectionName: `JUNIOR HUNTER CLASSIC & JUNIOR/AMATEUR OWNER CLASSIC COMBINED`,
  },
  { SectionCd: 3010, SectionName: `PONY HUNTER CLASSIC` },
  { SectionCd: 3011, SectionName: `GREEN PONY CLASSIC` },
  { SectionCd: 3020, SectionName: `AMATEUR HUNTER CLASSIC` },
  { SectionCd: 3050, SectionName: `OPEN HUNTER CLASSIC` },
  { SectionCd: 3030, SectionName: `USHJA INTERNATIONAL HUNTER DERBY` },
  { SectionCd: 3040, SectionName: `USHJA NATIONAL HUNTER DERBY` },
  { SectionCd: 3070, SectionName: `USHJA PONY HUNTER DERBY` },
  { SectionCd: 2900, SectionName: `LADIES SIDE SADDLE` },
  { SectionCd: 3109, SectionName: `THOROUGHBRED HUNTER` },
  { SectionCd: 3100, SectionName: `MISC. HUNTER (No points earned)` },
  { SectionCd: 6100, SectionName: `PESSOA/USEF HUNTER SEAT MEDAL` },
  { SectionCd: 6200, SectionName: `EQUISPORT/USEF PONY MEDAL` },
  { SectionCd: 6300, SectionName: `ADULT EQUITATION` },
  {
    SectionCd: 6110,
    SectionName: `PLATINUM PERFORMANCE/USEF SHOW JUMPING TALENT SEARCH`,
  },
  { SectionCd: 3110, SectionName: `COMBINED CHILD/ADULT EQUITATION` },
  { SectionCd: 3102, SectionName: `HUNTER EQUITATION 14&U` },
  { SectionCd: 3103, SectionName: `HUNTER EQUITATION 15-17` },
  { SectionCd: 3104, SectionName: `COMBINED HUNTER EQUITATION 17/U` },
  { SectionCd: 3105, SectionName: `ADULT EQUITATION 18-35` },
  { SectionCd: 3106, SectionName: `ADULT EQUITATION 36+` },
  { SectionCd: 3108, SectionName: `COMBINED ADULT EQUITATION 18+` },
  { SectionCd: 6360, SectionName: `USHJA HUNTER SEAT MEDAL` },
  {
    SectionCd: 3300,
    SectionName: `JUNIOR/AMATEUR OWNER JUMPER/AMATEUR (combined ages/heights)`,
  },
  { SectionCd: 3301, SectionName: `JUNIOR JUMPER (Junior/All heights)` },
  {
    SectionCd: 3302,
    SectionName: `AMATEUR OWNER JUMPER (Amateur/All heights)`,
  },
  { SectionCd: 3312, SectionName: `HIGH JUNIOR/AMATEUR OWNER/AMATEUR JUMPER` },
  { SectionCd: 3313, SectionName: `HIGH JUNIOR JUMPER` },
  { SectionCd: 3314, SectionName: `HIGH AMATEUR OWNER JUMPER` },
  {
    SectionCd: 3315,
    SectionName: `MEDIUM JUNIOR/AMATEUR OWNER/AMATEUR JUMPER`,
  },
  { SectionCd: 3316, SectionName: `MEDIUM JUNIOR JUMPER` },
  { SectionCd: 3317, SectionName: `MEDIUM AMATEUR OWNER JUMPER` },
  { SectionCd: 3318, SectionName: `LOW JUNIOR/AMATEUR OWNER/AMATEUR JUMPER` },
  { SectionCd: 3319, SectionName: `LOW JUNIOR JUMPER` },
  { SectionCd: 3320, SectionName: `LOW AMATEUR OWNER JUMPER` },
  { SectionCd: 3321, SectionName: `AMATUER JUMPER (all heights)` },
  { SectionCd: 3322, SectionName: `LOW AMATEUR JUMPER` },
  { SectionCd: 3323, SectionName: `MEDIUM AMATEUR JUMPER` },
  { SectionCd: 3324, SectionName: `HIGH AMATEUR JUMPER` },
  { SectionCd: 6350, SectionName: `USHJA 3'3" JUNIOR JUMPER SEAT MEDAL` },
  { SectionCd: 6349, SectionName: `USHJA 3'3" JUMPER SEAT MEDAL (COMBINED)` },
  { SectionCd: 6355, SectionName: `USHJA 3'3" ADULT JUMPER SEAT MEDAL ` },
  { SectionCd: 3111, SectionName: `THOROUGHBRED JUMPER` },
  { SectionCd: 3425, SectionName: `U25 JUMPER` },
  { SectionCd: 14000, SectionName: `USHJA JUMPER CLASSIC SERIES` },
  { SectionCd: 3400, SectionName: `Y/R JUMPER` },
  { SectionCd: 3500, SectionName: `CHILDREN/ADULT JUMPER` },
  { SectionCd: 3501, SectionName: `CHILDRENS JUMPER` },
  { SectionCd: 3502, SectionName: `ADULT AMATEUR JUMPER` },
  { SectionCd: 3700, SectionName: `$25,000 PLUS (GR. PRIX)` },
  { SectionCd: 3800, SectionName: `MISC JUMPER` },
  { SectionCd: 9500, SectionName: `PONY JUMPERS` },
  { SectionCd: 3600, SectionName: `SPECIAL JUMPER YEAR END AWARD` },
  { SectionCd: 9400, SectionName: `YOUNG JUMPERS` },
  { SectionCd: 9401, SectionName: `5-YEAR-OLD YOUNG JUMPERS` },
  { SectionCd: 9402, SectionName: `6-YEAR-OLD YOUNG JUMPERS` },
  { SectionCd: 9403, SectionName: `7/8-YEAR-OLD YOUNG JUMPER` },
  { SectionCd: 9403, SectionName: `7/8-YEAR-OLD YOUNG JUMPER` },
  { SectionCd: 9500, SectionName: `PONY JUMPERS` },
  { SectionCd: 2504, SectionName: `PONY HUNTER - SECTION B AT A SHOW` },
  { SectionCd: 2505, SectionName: `PONY HUNTER - SECTION C AT A SHOW` },
  { SectionCd: 2703, SectionName: `CHILDRENS HUNTER - YOUNGER` },
  { SectionCd: 2704, SectionName: `CHILDRENS HUNTER - OLDER` },
  { SectionCd: 2705, SectionName: `CHILDRENS HUNTER - SM MED PONY` },
  { SectionCd: 2707, SectionName: `CHILDRENS HUNTER - SECTION B AT A SHOW` },
  { SectionCd: 2816, SectionName: `ADULT AMATEUR SECTION B OF ONE AGE GROUP` },
  { SectionCd: 9000, SectionName: `GREEN 3' or 3'3" - SECTION B AT A SHOW` },
  { SectionCd: 9001, SectionName: `GREEN 3' or 3'3" - SECTION C AT A SHOW` },
  { SectionCd: 9002, SectionName: `GREEN 3' or 3'3" - SECTION D AT A SHOW` },
  { SectionCd: 9003, SectionName: `GREEN 3' or 3'3" - SECTION E AT A SHOW` },
  { SectionCd: 9003, SectionName: `GREEN 3'6" - SECTION B AT A SHOW` },
  { SectionCd: 9004, SectionName: `PERFORMANCE 3'3" - SECTION C AT A SHOW` },
  { SectionCd: 9005, SectionName: `JUNIOR HUNTER 3'3" YOUNGER` },
  { SectionCd: 9006, SectionName: `JUNIOR HUNTER 3'3" OLDER` },
]

export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const getFirstErrorKey = (object, keys = []) => {
  const firstErrorKey = Object.keys(object)[0]
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey])
  }
  return [...keys, firstErrorKey].join('.')
}

export const DiversityAndInclusionAdvocacyCommitteeId = '46';

export const programCalendarIds = {
  ghc: 1,
  ghi:2,
  hunter:3,
  'hunter-seat-medal':4,
  'jumper-classic':5,
  'jumping-seat':6,
  nhd:7,
  phd:8,
  'young-jumper':9
}

export const publicCalendarProgramIdsWithDesignation = [3, 6, 9];

//Rule Changes Comment section is managed by following properties
export const openRuleChangesComment = '10/01';
export const closeRuleChangesComment = '10/31';

export const enableRuleChangesComment= true;
